import React from 'react';
import PropTypes from 'prop-types';

import useMfaVerification from './hooks/useMfaVerification';
import MfaContext from './MfaContext';
import MfaModal from './MfaModal';

/**
 * App-level MFA provider. Mount once near the app root (inside the Intl and
 * Overlay providers). It renders the single TOTP MfaModal and exposes the
 * challenge runner to the whole tree via context, so any component can gate an
 * operation behind MFA with the useMfa() hook:
 *
 *   const runWithMfa = useMfa();
 *   const response = await runWithMfa((mfaCode) => someApi(payload, mfaCode));
 */
function MfaProvider({ children }) {
  const { run, modalProps } = useMfaVerification();

  return (
    <MfaContext.Provider value={run}>
      {children}
      <MfaModal
        isOpen={modalProps.isOpen}
        isVerifying={modalProps.isVerifying}
        errorCode={modalProps.errorCode}
        onSubmit={modalProps.onSubmit}
        onClose={modalProps.onClose}
      />
    </MfaContext.Provider>
  );
}

MfaProvider.propTypes = {
  children: PropTypes.node,
};

MfaProvider.defaultProps = {
  children: null,
};

export default MfaProvider;
